import { KycStatus } from "types/admin";

export const NON_VERIFIED_KYC_STATUS_OPTIONS: KycStatus[] = [
  "KYC_INITIATED",
  "PAN_VERIFIED",
  "BANK_VERIFIED",
  "GST_REQUIRED",
  "GST_VERIFICATION_PENDING",
  "GST_VERIFIED",
];

export function formatKycStatusLabel(status: KycStatus): string {
  return status.replace(/_/g, " ");
}
